"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoSuspenders = void 0;

var _react = require("react");

var _ = require(".");

var _VideoController = require("./controllers/VideoController");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * useVideoSuspenders returns two methods to resume and pause a video
 *
 * @param {*} ref
 * @return {*}
 */
var useVideoSuspenders = function useVideoSuspenders(ref) {
  var _useVideoControls = (0, _.useVideoControls)(ref),
      play = _useVideoControls.play,
      pause = _useVideoControls.pause,
      videoController = _useVideoControls.videoController;

  var wasPaused = false;
  var otherController = _VideoController.VideoController._instances.length > 0 ? _VideoController.VideoController._instances[0] : null;
  var suspend = (0, _react.useCallback)(function () {
    if (videoController) {
      wasPaused = videoController.paused;
    } else if (otherController) {
      wasPaused = otherController.paused;
    } else {
      wasPaused = false;
    }

    pause();
  }, [pause]);
  var resume = (0, _react.useCallback)(function (force) {
    if (!wasPaused || force) {
      console.log("useVideoSuspender: resuming video");
      play();
    }
  }, [play]);
  return {
    suspend: suspend,
    resume: resume
  };
};

exports.useVideoSuspenders = useVideoSuspenders;